import React from 'react'
import ReactPlayer from 'react-player/vimeo'
import {FaPlay} from 'react-icons/fa'
import {Link, useLocation, useNavigate} from 'react-router-dom'

function Tab4({values, handleChange, setFieldValue}) {
  const navigate = useNavigate()
  let imageURL = ''
  if (values.isEdit) {
    if (values.bannerImage) {
      imageURL = values.bannerImage ? URL.createObjectURL(values.bannerImage) : ''
    } else {
      imageURL = values.bannerImgUrl || values.imgUrl
    }
  } else {
    imageURL = values.bannerImage ? URL.createObjectURL(values.bannerImage) : values.image ? URL.createObjectURL(values.image) : ''
  }

  return (
    <div className='pt-4 px-4 mb-3' style={{fontSize: '14px'}}>
      <div className='d-flex align-items-start gap-3'>
        {values.bannerImage || values.bannerImgUrl || values.image || values.imgUrl ? (
          <img
            style={{cursor: 'pointer', width: '512px', height: '256px', objectFit:'cover'}}
            src={imageURL}
            alt=''
          ></img>
        ) : (
          <img style={{width: '512px', height: '256px'}} src='https://placehold.co/512x256?text= No Image' />
        )}
        <div className='d-flex flex-column t-14 gap-2 mt-2'>
        <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Code:</div>
            <div>{values?.code}</div>
          </div>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Title:</div>
            <div>{values?.title}</div>
          </div>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Author Name:</div>
            <div>{values?.authorName}</div>
          </div>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Language:</div>
            <div>{values?.language}</div>
          </div>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Cohort:</div>
            <div>{values?.cohort}</div>
          </div>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Category:</div>
            <div>{values?.category}</div>
          </div>
          <div className='d-flex gap-1'>
            <div className='fw-bold m-0'>Tags:</div>
            <div>
              {values?.tags?.map((val, index) =>
                values?.tags?.length - 1 === index ? val : val + ', '
              )}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className='fw-bold mt-8'>Modules</div>
        <div className='me-lg-5'>
          {' '}
          {values.modules.map((val, index) => (values.modules.length - 1 === index ? val : val + ', '))}
        </div>
      </div>

      <hr className='hr-3 my-8' />
      <div className='mt-3'>
        <div className='fw-bold mt-8'>Short Description</div>
        <div className='mt-2'>{values.shortDescription}</div>
      </div>

      <div className='mt-5'>
        <div className='fw-bold mt-8'>Detailed Description</div>
        <div className='mt-2 '>{values.longDescription}</div>
      </div>
    </div>
  )
}

export default Tab4
